import type { ProjectState } from 'app/store/project/project.state';
import type { Uuid } from 'shared/common/types';
import { createSelector } from '@ngrx/store';
import { selectProjectState } from 'app/store/project/project.state';
import * as fromStatusChains from './status-chains.reducer';

export const statusChainsState = createSelector(
  selectProjectState,
  state => state.statusChains,
);

export const statusChains = createSelector(
  selectProjectState,
  (state: ProjectState) => fromStatusChains.selectAll(state.statusChains),
);

export const statusChainEntities = createSelector(
  selectProjectState,
  state => fromStatusChains.selectEntities(state.statusChains),
);

export const oneStatusChain = createSelector(
  selectProjectState,
  (state: ProjectState, props: { id: Uuid }) => fromStatusChains.selectEntities(state.statusChains)[props.id],
);

export const statusChainsLoading = createSelector(
  selectProjectState,
  state => state.statusChains.loading,
);
